// extracted by mini-css-extract-plugin
export var container = "_j2-0";
export var content = "_j2-3";
export var customerTitle = "_j2-4";
export var empty = "_j2-5";
export var gray = "_j2-6";
export var header = "_j2-7";
export var info = "_j2-8";
export var loading = "_j2-2";
export var loadingCard = "_j2-9";
export var oneLine = "_j2-a";
export var personName = "_j2-e";
export var pillContainer = "_j2-b";
export var selected = "_j2-1";
export var text = "_j2-c";
export var twoLines = "_j2-d";
export var unread = "_j2-f";
export var unreadIndicator = "_j2-g";